import { PortHolidaysUpload } from "./components/PortHolidaysUpload"

const routes = [{ path: "/port-holidays-upload", component: PortHolidaysUpload }]

const settings = {
  routes,
}
export default settings
